"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDareMessageByPlatform = exports.useDareRequirementMessages = void 0;
const useConnectedPlatformsByDares_1 = require("root/src/client/logic/dropEvent/hooks/useConnectedPlatformsByDares");
const useUser_1 = require("root/src/client/logic/userData/hooks/useUser");
const useDropEvent_1 = require("root/src/client/logic/dropEvent/hooks/useDropEvent");
const calculateMaxDares_1 = require("root/src/shared/util/calculateMaxDares");
const useMaxDaresByPlatform_1 = require("root/src/client/logic/dropEvent/hooks/useMaxDaresByPlatform");
const platforms_1 = require("root/src/shared/@types/platforms");
const providers_1 = __importStar(require("root/src/shared/constants/providers"));
const dropEvent_1 = require("root/src/shared/constants/dropEvent");
const useDareRequirementMessages = () => {
    const { connectedPlatforms, averageCcv } = (0, useUser_1.useUserCreatorData)();
    const dropEvent = (0, useDropEvent_1.useDropEvent)();
    const isBrand = (0, useUser_1.useIsBrand)();
    const followerCountByPlatform = (0, useUser_1.useCreatorFollowersCountByPlatform)();
    const isAuthenticated = (0, useUser_1.useIsAuthenticated)();
    const connectedPlatformsByDaresPlatform = (0, useConnectedPlatformsByDares_1.useConnectedPlatformsByDares)();
    const maxDaresByUserPlatforms = (0, useMaxDaresByPlatform_1.useMaxDaresByPlatform)({ platform: platforms_1.DarePlatform.Any });
    if (!dropEvent) {
        return [];
    }
    if (!isAuthenticated) {
        return ['Sign in to get started'];
    }
    if (isBrand) {
        return [];
    }
    if (!connectedPlatforms.length) {
        return ['Connect a channel to get started.'];
    }
    if (maxDaresByUserPlatforms === 0) {
        return [dropEvent_1.notEnoughViewershipMessage];
    }
    return connectedPlatformsByDaresPlatform.map((platform) => {
        const maxDares = (0, calculateMaxDares_1.calculateMaxDaresByPlatform)({
            followerCount: followerCountByPlatform[platform],
            averageCcv,
            platform,
            campaign: dropEvent,
        });
        return getDareMessageByPlatform({ maxDares, dropEvent, connectedPlatforms, platform });
    });
};
exports.useDareRequirementMessages = useDareRequirementMessages;
function getDareMessageByPlatform({ platform, dropEvent, maxDares, connectedPlatforms, }) {
    if (!dropEvent) {
        return null;
    }
    const isCcvBreakpoints = Boolean(dropEvent.ccvBreakpoints.length);
    const isFollowersBreakpoints = Boolean(dropEvent.followersBreakpoints.length);
    if (!connectedPlatforms.includes(platform)) {
        return null;
    }
    if (platform === providers_1.default.twitch && !isCcvBreakpoints) {
        return 'Based on your CCV, you can accept ALL Twitch dares. ';
    }
    if (platform === providers_1.default.youtube && !isFollowersBreakpoints /* TODO fix for just yt bp */) {
        return 'Based on your YouTube viewership, you can accept ALL YouTube dares. ';
    }
    if (platform === providers_1.default.tiktok && !isFollowersBreakpoints /* TODO fix for just tt bp */) {
        return 'Based on your TikTok viewership, you can accept ALL TikTok dares. ';
    }
    if (!isCcvBreakpoints && !isFollowersBreakpoints) {
        return null;
    }
    return `Based on your ${providers_1.platformsLabelMap[platform]} viewership you can accept ${Number.isFinite(maxDares) ? maxDares : 'ALL'} ${providers_1.platformsLabelMap[platform]} dares. `;
}
exports.getDareMessageByPlatform = getDareMessageByPlatform;
